import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type ConsentsAndDeclarationsModuleSpecsFragment } from '../../../../../api/fragments/ConsentsAndDeclarationsModuleSpecs';
import {
    CreateConsentsAndDeclarationsModuleDocument,
    type CreateConsentsAndDeclarationsModuleMutation,
    type CreateConsentsAndDeclarationsModuleMutationVariables,
} from '../../../../../api/mutations/createConsentsAndDeclarationsModule';
import { type ConsentsAndDeclarationsModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import ConsentsAndDeclarationsModulePage, {
    type ConsentsAndDeclarationsModulePageProps,
} from '../../ConsentsAndDeclarationsModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<
    ConsentsAndDeclarationsModuleSpecsFragment,
    ConsentsAndDeclarationsModuleSettings
> = {
    PageComponent: ({ module }: ConsentsAndDeclarationsModulePageProps) => (
        <ConsentsAndDeclarationsModulePage module={module} />
    ),
    getTitle: t => t('moduleDetails:implementations.ConsentsAndDeclarationsModule.className'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    getValidator: () => validators.compose(validators.requiredNonEmptyString('displayName')),
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateConsentsAndDeclarationsModuleMutation, CreateConsentsAndDeclarationsModuleMutationVariables>({
                mutation: CreateConsentsAndDeclarationsModuleDocument,
                variables: { companyId, settings: values },
            })
            .then(({ data }) => data.module),
};

export default implementation;
